import i18n, { type InitOptions } from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const SUPPORTED_LANGUAGES = ['ru', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const NAMESPACES = ['common', 'stays', 'rooms', 'staff', 'requests'] as const;
export type Namespace = (typeof NAMESPACES)[number];

export interface InitI18nOptions {
  /** Public URL where locale JSONs live, default `/locales`. */
  loadPath?: string;
  /** Default language, default `en`. */
  fallbackLng?: SupportedLanguage;
  /** Lockstep `lng` (skip detection), useful for tests. */
  lng?: SupportedLanguage;
}

export async function initI18n(opts: InitI18nOptions = {}): Promise<typeof i18n> {
  if (i18n.isInitialized) return i18n;

  const initOpts: InitOptions = {
    fallbackLng: opts.fallbackLng ?? 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    ns: [...NAMESPACES],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    backend: {
      loadPath: `${opts.loadPath ?? '/locales'}/{{lng}}/{{ns}}.json`,
    },
    react: { useSuspense: false },
  };
  if (opts.lng !== undefined) initOpts.lng = opts.lng;

  await i18n.use(HttpBackend).use(initReactI18next).init(initOpts);

  return i18n;
}

export { i18n };
export { useTranslation, Trans, I18nextProvider } from 'react-i18next';
